import React, { useState } from 'react';
import './aluminiumwindow.css';

import {
  FaLayerGroup,
  FaShieldAlt,
  FaRegBuilding,
  FaThermometerHalf,
  FaCompressArrowsAlt,
  FaPaintRoller
} from 'react-icons/fa';

function WallCladding() {
  const [activeTab, setActiveTab] = useState('types');
  const [selectedImage, setSelectedImage] = useState(0);

  const images = [
        '/cladding 2.jpg',
    '/wall cladding 1.jpg',

    '/wall cladding 3.webp',
    '/wall cladding.webp',
    '/wall cladding 5.png',
  ];

  const features = [
    {
      icon: <FaLayerGroup />,
      title: 'Premium Cladding Systems',
      description: 'High-quality aluminium cladding designed for exterior and interior applications'
    },
    {
      icon: <FaShieldAlt />,
      title: 'Weather Protection',
      description: 'Protects building surfaces from harsh weather, moisture, and UV exposure'
    },
    {
      icon: <FaThermometerHalf />,
      title: 'Thermal Performance',
      description: 'Improves insulation and reduces heat transfer in buildings'
    },
    {
      icon: <FaRegBuilding />,
      title: 'Architectural Appeal',
      description: 'Enhances façade aesthetics with modern textures and finishes'
    },
    {
      icon: <FaCompressArrowsAlt />,
      title: 'Lightweight Structure',
      description: 'Strong yet lightweight panels reduce structural load'
    },
    {
      icon: <FaPaintRoller />,
      title: 'Custom Finishes',
      description: 'Available in metallic, wood-grain, stone, and custom colors'
    }
  ];

  const claddingTypes = [
    { name: 'Aluminium Composite Panels (ACP)', image: '/Aluminium Composite Panels.jpg' },
    { name: 'Solid Aluminium Panels', image: '/solid aluminium.jpg' },
    { name: 'Ventilated Façade Systems', image: '/ventilated facade.png' },
    { name: 'Interior Wall Cladding', image: '/Interior-Wall-Cladding.jpg' },
  ];

  const specifications = [
    { label: 'Material', value: 'Aluminium / ACP Panels' },
    { label: 'Panel Thickness', value: '3mm – 6mm' },
    { label: 'Finish', value: 'PVDF / Powder Coated' },
    { label: 'Fire Rating', value: 'Fire Retardant Options Available' },
    { label: 'Weather Resistance', value: 'UV & Corrosion Resistant' },
    { label: 'Installation', value: 'Dry & Mechanical Fixing' },
    { label: 'Customization', value: 'Colors, Textures & Patterns' },
    { label: 'Warranty', value: '10–15 Years' }
  ];

  return (
    <div className="aluminium-window">

      {/* Hero Section */}
      <section className="aluminium-hero">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">Aluminium Wall Cladding</h1>
            <p className="hero-subtitle">
              Modern wall cladding solutions that enhance building aesthetics,
              durability, and energy efficiency for exterior and interior spaces.
            </p>
          </div>

          <div className="hero-image">
            <img
              src={images[selectedImage]}
              alt="Aluminium Wall Cladding"
              className="hero-main-image"
            />
            <div className="image-thumbnails">
              {images.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`Wall Cladding ${index + 1}`}
                  className={`thumbnail ${selectedImage === index ? 'active' : ''}`}
                  onClick={() => setSelectedImage(index)}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="features-section">
        <div className="section-header">
          <h2>Why Choose Our Wall Cladding?</h2>
          <p>Engineered for durability, protection, and architectural beauty</p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Tabs */}
      <section className="tabs-section">
        <div className="tabs-header">
          <button
            className={`tab-btn ${activeTab === 'types' ? 'active' : ''}`}
            onClick={() => setActiveTab('types')}
          >
            Cladding Types
          </button>

          <button
            className={`tab-btn ${activeTab === 'benefits' ? 'active' : ''}`}
            onClick={() => setActiveTab('benefits')}
          >
            Benefits
          </button>
        </div>

        <div className="tabs-content">

          {activeTab === 'types' && (
            <div className="window-types-grid">
              {claddingTypes.map((type, index) => (
                <div key={index} className="window-type-card">
                  <img src={type.image} alt={type.name} />
                  <h4>{type.name}</h4>
                </div>
              ))}
            </div>
          )}

          {activeTab === 'benefits' && (
            <div className="benefits-content">
              <div className="benefit-card">
                <h3>Enhanced Building Protection</h3>
                <p>Shields walls from weather damage, moisture, and pollution.</p>
              </div>
              <div className="benefit-card">
                <h3>Modern Architectural Finish</h3>
                <p>Adds a premium, contemporary appearance to any structure.</p>
              </div>
              <div className="benefit-card">
                <h3>Energy Efficiency</h3>
                <p>Improves thermal performance and indoor comfort.</p>
              </div>
              <div className="benefit-card">
                <h3>Low Maintenance</h3>
                <p>Requires minimal upkeep with long-lasting finishes.</p>
              </div>
            </div>
          )}

        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="cta-content">
          <h2>Enhance Your Building Façade</h2>
          <p>Contact us for customized aluminium wall cladding solutions</p>
          <div className="cta-buttons">
            <a href="/contactus">
              <button className="btn-outline">Contact Us</button>
            </a>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="faq-section">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-grid">
          <div className="faq-item">
            <h4>Is aluminium wall cladding suitable for exteriors?</h4>
            <p>Yes, it is designed to withstand harsh outdoor conditions and protect building façades.</p>
          </div>
          <div className="faq-item">
            <h4>Are fire-rated cladding options available?</h4>
            <p>Yes, fire-retardant ACP and aluminium panels are available upon request.</p>
          </div>
          <div className="faq-item">
            <h4>Can colors and textures be customized?</h4>
            <p>Absolutely. We offer a wide range of finishes including wood-grain and metallic textures.</p>
          </div>
          <div className="faq-item">
            <h4>Where is wall cladding commonly used?</h4>
            <p>Commercial buildings, offices, malls, hotels, and residential façades.</p>
          </div>
        </div>
      </section>

    </div>
  );
}

export default WallCladding;
